import { prepareForSlot } from '@mui/base'
import { type FC } from 'react'

import { Link } from 'base-ui'

import { type AlgoliaRecord } from '../../../algolia'
import { urlGetRelativeUrl } from '../../../url-handling'

import { StoryblokProductBatteryLink } from './StoryblokProductBatteryLink'

const LinkSlot = prepareForSlot(StoryblokProductBatteryLink)

type Props = {
  product: AlgoliaRecord
}

export const StoryblokProductBatteryName: FC<Props> = ({ product }) => {
  return (
    <Link
      className="line-clamp-3 font-medium no-underline"
      color="inherit"
      data-analytics="item-title"
      data-qa-id={`form-product-slider-${product.objectID}-link-button`}
      href={urlGetRelativeUrl(product.deeplink) ?? '/'}
      slots={{ root: LinkSlot }}
      title={product.productName}
    >
      {product.productName}
    </Link>
  )
}
